export default __webpack_public_path__ + "static/media/gradient-square.a8558772.svg";